import React from 'react';
import { Link } from 'react-router-dom';
import { UserPlus, CreditCard, Search, MessageCircle, Heart } from 'lucide-react';

const steps = [
  { icon: UserPlus, title: 'Choose Your Role', desc: 'Service Provider (Hire a friend) or Regular User (premium access).' },
  { icon: CreditCard, title: 'Create a Premium Account', desc: 'Service Providers: ₹5,000 one-time. Regular Users: ₹1,000 one-time. No monthly or hidden fees.' },
  { icon: Search, title: 'Profile Creation & Verification', desc: 'Upload photo, fill interests, verify identity. Get your Verified badge.' },
  { icon: MessageCircle, title: 'Explore & Connect', desc: 'Browse verified profiles, filter by gender/city/interests. Start messaging on the platform.' },
  { icon: Heart, title: 'Build Real Connection', desc: 'Chat, understand each other, and build friendships based on mutual respect.' },
];

const HowItWorksPage = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-heading font-bold text-3xl text-white mb-4">
        How It Works – Stranger69.net
      </h1>
      <p className="text-slate-400 mb-12">
        We provide a premium, safe platform for real human connection. Text chat only on-site;
        contact exchange after mutual agreement.
      </p>
      <div className="space-y-8">
        {steps.map(({ icon: Icon, title, desc }, i) => (
          <div key={i} className="flex gap-4">
            <div className="w-12 h-12 rounded-xl bg-brand-pink/20 flex items-center justify-center shrink-0">
              <Icon className="h-6 w-6 text-brand-pink" />
            </div>
            <div>
              <h2 className="font-semibold text-white text-lg">{title}</h2>
              <p className="text-slate-400 mt-1">{desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-12 flex gap-4">
        <Link
          to="/register?role=user"
          className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-brand-pink text-white font-semibold hover:bg-brand-pink-dark"
        >
          Join as User
        </Link>
        <Link
          to="/register?role=provider"
          className="inline-flex items-center justify-center px-6 py-3 rounded-xl border-2 border-slate-500 text-slate-300 font-semibold hover:border-brand-pink hover:text-brand-pink"
        >
          Become a Friend
        </Link>
      </div>
    </div>
  );
};

export default HowItWorksPage;
